export const stringSearch = (search?: string) => {
  let key = search;

  const unmasked = search?.replace(/\.|-/gm, '');

  const isNumber = /^\d+$/.test(unmasked);

  const isEmail = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(search);

  if (!(isEmail && isNumber)) {
    key = search.toLocaleLowerCase();
  }

  if (isNumber) {
    key = unmasked;
  }

  return key;
};
